const Products = () =>{

    return (
        <h1>Hi from Products</h1>
    )
}

export default Products